import { render, staticRenderFns } from "./ServiceType.vue?vue&type=template&id=27e02d5e&scoped=true&"
import script from "./ServiceType.vue?vue&type=script&lang=js&"
export * from "./ServiceType.vue?vue&type=script&lang=js&"
import style0 from "./ServiceType.vue?vue&type=style&index=0&id=27e02d5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e02d5e",
  null
  
)

export default component.exports